import validate from "/app/node_modules/.pnpm/nuxt@4.4.6_@babel+plugin-proposal-decorators@7.29.7_@babel+core@7.29.7__@babel+plugin-s_f7c2dbc4d9acd8450f0428bfc8612da0/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45legacy_45category_45global from "/app/apps/landing2-ui/middleware/redirect-legacy-category.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.4.6_@babel+plugin-proposal-decorators@7.29.7_@babel+core@7.29.7__@babel+plugin-s_f7c2dbc4d9acd8450f0428bfc8612da0/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  redirect_45legacy_45category_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}